module.exports = __webpack_public_path__ + "img/promo-bg--767.6b19db8.webp";